import * as React from 'react';
import './initialCoachingV2Notice.module.scss';
import { Link } from 'react-router-dom';
import { NonSpBr } from '../../../../commonv3/components/atoms/layouts/br';
import { V3Routes } from '../../../routes';

export const InitialCoachingV2Notice = () => (
    <div id="initial-coaching-v2-notice" styleName="notice">
        ※コーチングの内容は2020年7月からリニューアルいたします。<NonSpBr />
        詳細は<Link to={V3Routes.coachingSessionsIntroduction()}>こちら</Link>からご確認ください。
    </div>
);
